export const EDIT_INITIATIVE_REQUEST = 'EDIT_INITIATIVE_REQUEST';
export const EDIT_INITIATIVE_SUCCESS = 'EDIT_INITIATIVE_SUCCESS';
export const EDIT_INITIATIVE_FAILED = 'EDIT_INITIATIVE_FAILED';

export const GET_INITIATIVE_REQUEST = 'GET_INITIATIVE_REQUEST';
export const GET_INITIATIVE_SUCCESS = 'GET_INITIATIVE_SUCCESS';
export const GET_INITIATIVE_FAILED = 'GET_INITIATIVE_FAILED';

export const GET_PDF_PREVIEW_REQUEST = 'GET_PDF_PREVIEW_REQUEST';
export const GET_PDF_PREVIEW_SUCCESS = 'GET_PDF_PREVIEW_SUCCESS';
export const GET_PDF_PREVIEW_FAILED = 'GET_PDF_PREVIEW_FAILED';
